import ChevronIcon from "@/assets/Chevron";
import { INode } from "../../SurveyModel/types/nodeTypes";
import { useState } from "react";

interface IInfoList extends INode {
    node: INode;
    items: InfoListItem[];
}

type InfoListItem = {
  label: string;
  value: string; // e.g. "1.5 units"
};


const InfoList = ({ node }: IInfoList) => {
    const { title, items } = node as IInfoList;
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };


    return (
        <div className="info-list-wrapper w-[418px]">
            <button onClick={toggleExpanded} className="title">
                {title} 
                <div className="mt-1">
                    <ChevronIcon rotateUp={isExpanded}/>
                </div>
            </button>
            {isExpanded && (
                <ul className="list">
                    {items.map((item, index) => (
                        <li key={index} className="list-item">
                            <span className="label">{item.label}</span>
                            <span className="value">{item.value}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default InfoList;